import { capitalizeFirstLetterWithDelimiter } from '~/utils/string'

export class SocialModel {
  private readonly _link: string
  private readonly _channel: string
  private readonly _socialType: string

  constructor (channel: string, socialType: string, link: string) {
    this._link = link
    this._channel = channel
    this._socialType = socialType
  }

  get link () {
    return this._link
  }

  get name () {
    return capitalizeFirstLetterWithDelimiter(this._channel || this._socialType, '_')
  }

  get icon () {
    if (this._socialType === 'HOME') {
      return 'web'
    }
    return `social/${this._socialType.toLowerCase()}`
  }
}